var map = {
	"./block.svg": "BdFb",
	"./competition.svg": "wH43",
	"./download.svg": "+H2/",
	"./end.svg": "hqr5",
	"./find.svg": "9pbe",
	"./home.svg": "U9Ws",
	"./lesson.svg": "6hTy",
	"./look.svg": "Ed7H",
	"./my.svg": "kBws",
	"./playCode.svg": "Fmqe",
	"./python.svg": "p5Wv",
	"./robot.svg": "ARn3",
	"./settings.svg": "rPJQ",
	"./system.svg": "Jax1",
	"./zan-active.svg": "n/OJ",
	"./zan.svg": "M++c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 0